import { render } from "./BestSalesSection.vue?vue&type=template&id=af8421a4&scoped=true"
import script from "./BestSalesSection.vue?vue&type=script&lang=js"
export * from "./BestSalesSection.vue?vue&type=script&lang=js"

import "./BestSalesSection.vue?vue&type=style&index=0&id=af8421a4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8421a4"]])

export default __exports__